import React from 'react';
import classnames from 'classnames';
import {
  type ComponentProps,
  type LabelPillElement,
} from '../../../types/aha-editor';
import { sanitizeLabelPillColor } from '../utils';
import styles from './LabelPill.module.css';

const LabelPillComponent: React.FC<ComponentProps<LabelPillElement>> = ({
  attributes,
  element,
  children,
}) => {
  const color = sanitizeLabelPillColor(element.pill_colorScheme);

  return (
    <span
      className={classnames(styles.labelPill, styles[color])}
      {...attributes}
    >
      {children}
    </span>
  );
};

export default LabelPillComponent;
